import { jsx as _jsx } from "react/jsx-runtime";
import { suggest_Check_str, general_ConnectOn_str, } from '@zenlayer/zen-design-icons';
import { useState } from 'react';
import t from '@zenlayer/zen-intl18';
import { SvgIcon, Tooltip } from '@zenlayer/zen-design';
import { copyToClipboard } from '../../common/utils';
import cls from './index.module.less';
export const Copy = ({ copyUrl }) => {
    const [showCopy, setShowCopy] = useState(false);
    return (_jsx("div", { className: cls.icon, children: _jsx(Tooltip, { title: showCopy ? t('ZjE0xSBkITK8') : t('5bK2APBEsikB'), children: _jsx("span", { onClick: () => {
                    copyToClipboard(copyUrl);
                    setShowCopy(true);
                }, onMouseLeave: () => {
                    setTimeout(() => {
                        setShowCopy(false);
                    }, 1000);
                }, children: showCopy ? (_jsx(SvgIcon, { className: cls.successIcon, style: { color: '#0c9' }, svgStr: suggest_Check_str })) : (_jsx(SvgIcon, { svgStr: general_ConnectOn_str })) }) }) }));
};
